import {
  mediaFragment,
  responsiveMediaFragment
} from '~/gql/mediaFragments.gql'
import {
  seoFragment,
  productCardFragment
} from '@/gql/fragments.gql.js'

export const athleteHero = `
  ${mediaFragment('image', '{ q: 40 }')}
  ${mediaFragment('mobileImage', '{ q: 40 }')}
  ${mediaFragment('video', null, false)}
  ${mediaFragment('mobileVideo', null, false)}
  sport
  sportSubtitle
  subtitleGradient
  overlayOpacity
`

export const athleteGql = `
query Athlete ($slug: String!) {
  athlete(filter: { slug: { eq: $slug } }) {
    id
    title
    slug
    _firstPublishedAt
    createdAt
    ${athleteHero}
    content {
      value
      links
      blocks {
        ... on LargeCopyRecord {
          __typename
          _modelApiKey
          id
          smallText
          copy
        }
        ... on ArticleImageRecord {
          __typename
          _modelApiKey
          id
          caption
          credit
          ${responsiveMediaFragment()}
          productCards {
            title
            product {
              sku
              title
              subTitle
              frameSwatchOverride
              lensSwatchOverride
              swatchIconOverride {
                url(imgixParams: {w: "50", h: "50"})
              }
              lensPart
              limitedEdition
              ${mediaFragment('logo', '{ w: "200", h: "100", fit: fill }')}
              stockManagedPart
              theme
              baseProduct {
                sku
              }
            }
          }
        }
        ... on ArticleProductCardRecord {
          __typename
          _modelApiKey
          id
          heading
          productCard {
            ${productCardFragment}
          }
        }
        ... on ArticleVideoRecord {
          __typename
          _modelApiKey
          id
          video {
            url
            thumbnailUrl
            height
            width
            provider
            providerUid
            title
          }
          scrollToId
        }
        ... on ArticleCarouselRecord {
          __typename
          _modelApiKey
          id
          caption
          ${responsiveMediaFragment('images')}
        }
      }
    }
    dateOfBirth
    metaItems {
      title
      copy
    }
    socialHandle
    socialHandleType
    tags {
      id
      title
    }
    ${seoFragment}
  }
}
`

export const athleteListGql = `
query AthleteList ($limit: IntType!, $offset: IntType!) {
  athletesMeta: _allAthletesMeta {
    count
  }
  allAthletes(skip: $offset, first: $limit) {
    id
    title
    subtitle
    slug
    ${mediaFragment('media')}
  }
}`